/**
 * The one place that maps an attention item's deep-link `target` → a concrete navigation action, so the
 * dashboard cockpit, the bell, and any future surface route an item IDENTICALLY. The target shape mirrors
 * `AttentionTarget` in `packages/server/src/services/attention.ts` (the web can't import server types).
 *
 * Today the app can deep-focus a deal or a customer and switch to any view; the fuller refType→record
 * routing contract (release/prices-subtab/accounting/cheque) lands in CW-10. Until then a focus-less item
 * (e.g. the cash-shortfall) routes to its view, which is still one click to the right screen.
 */
export interface AttentionTargetLike {
  view: string;
  focusKind?: 'deal' | 'customer';
  focusId?: number;
}

export type AttentionNav =
  { kind: 'deal'; id: number } | { kind: 'customer'; id: number } | { kind: 'view'; view: string };

export function attentionNav(target: AttentionTargetLike): AttentionNav {
  if (target.focusKind === 'deal' && typeof target.focusId === 'number') {
    return { kind: 'deal', id: target.focusId };
  }
  if (target.focusKind === 'customer' && typeof target.focusId === 'number') {
    return { kind: 'customer', id: target.focusId };
  }
  return { kind: 'view', view: target.view };
}
